import axios from 'axios';

// TODO use maybeReportExceptionInterceptor once maybeReportException is shared

export default axios.create({
  baseURL: '/api',
  headers: { 'X-Api-Version': '1' },
});
